
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ExhibitionPage = () => {
  const [selectedExhibit, setSelectedExhibit] = useState<string | null>(null);

  const exhibits = [
    {
      id: 'chatyen',
      title: 'ChatYen AI互動系統',
      description: '透過AI技術重現嚴家淦總統的智慧與思維，讓參觀者能與歷史人物進行對話互動。',
      image: 'https://public.readdy.ai/ai/img_res/140b59a8a390a606ecc4bde6256f4fb9.jpg',
      features: ['語音對話', 'AI問答', '歷史重現', '互動體驗']
    },
    {
      id: 'vr-finance',
      title: '財經制度重建VR',
      description: '沉浸式體驗嚴家淦推動的幣制改革與經濟建設，親身感受台灣經濟奇蹟的形成過程。',
      image: 'https://readdy.ai/api/search-image?query=Virtual%20reality%20exhibition%20showing%201950s%20Taiwan%20economic%20development%2C%20vintage%20office%20setting%20with%20financial%20documents%20and%20charts%2C%20immersive%20VR%20headset%20display%2C%20historical%20atmosphere%20with%20warm%20sepia%20tones&width=600&height=400&seq=vrfinance&orientation=landscape',
      features: ['VR沉浸體驗', '歷史場景重現', '經濟數據視覺化', '互動學習']
    },
    {
      id: 'diplomacy-360',
      title: '外交橋梁360度沉浸體驗',
      description: '360度全景展示嚴家淦時期的外交成就，體驗國際舞台上的重要時刻。',
      image: 'https://readdy.ai/api/search-image?query=360-degree%20immersive%20diplomatic%20exhibition%20hall%20with%20world%20map%20projections%2C%20international%20flags%2C%20vintage%20diplomatic%20meeting%20scenes%2C%20sophisticated%20lighting%20design%2C%20museum%20visitors%20wearing%20VR%20headsets&width=600&height=400&seq=diplomacy360&orientation=landscape',
      features: ['360度全景', '外交歷史', '國際視野', '多媒體展示']
    },
    {
      id: 'tea-culture',
      title: '歷史茶席區＋文化永續展',
      description: '結合傳統茶文化與歷史教育，在品茗中感受嚴家淦的文化理念與永續思維。',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20tea%20ceremony%20exhibition%20space%20with%20elegant%20wooden%20furniture%2C%20vintage%20tea%20sets%2C%20cultural%20artifacts%20display%2C%20warm%20ambient%20lighting%2C%20visitors%20participating%20in%20tea%20ceremony%2C%20serene%20atmosphere&width=600&height=400&seq=teaculture&orientation=landscape',
      features: ['傳統茶席', '文化體驗', '歷史教育', '永續理念']
    }
  ];

  const exhibitionInfo = {
    title: 'Hello, President! 嚴家淦總統120周年互動展',
    period: '2025年11月14日至12月24日',
    time: '09:30–17:00',
    location: '國定古蹟自由之家',
    theme: '中庸治世．科技立國．文化永續'
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-amber-50 to-stone-100">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl font-bold text-stone-800 mb-6">
              {exhibitionInfo.title}
            </h1>
            <p className="text-xl text-stone-600 mb-8">
              {exhibitionInfo.theme}
            </p>
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-lg">
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-amber-600 mb-2">
                    <i className="ri-calendar-line text-2xl"></i>
                  </div>
                  <h3 className="font-semibold text-stone-800 mb-1">展期</h3>
                  <p className="text-stone-600">{exhibitionInfo.period}</p>
                </div>
                <div>
                  <div className="text-amber-600 mb-2">
                    <i className="ri-time-line text-2xl"></i>
                  </div>
                  <h3 className="font-semibold text-stone-800 mb-1">時間</h3>
                  <p className="text-stone-600">{exhibitionInfo.time}</p>
                </div>
                <div>
                  <div className="text-amber-600 mb-2">
                    <i className="ri-map-pin-line text-2xl"></i>
                  </div>
                  <h3 className="font-semibold text-stone-800 mb-1">地點</h3>
                  <p className="text-stone-600">{exhibitionInfo.location}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Exhibition Highlights */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-stone-800 mb-6">展覽亮點</h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              運用最新科技與傳統文化相結合，打造沉浸式歷史體驗
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {exhibits.map((exhibit) => (
              <div
                key={exhibit.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
                onClick={() => setSelectedExhibit(exhibit.id)}
              >
                <div className="aspect-video overflow-hidden">
                  <img
                    src={exhibit.image}
                    alt={exhibit.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-stone-800 mb-4">
                    {exhibit.title}
                  </h3>
                  <p className="text-stone-600 mb-6 leading-relaxed">
                    {exhibit.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {exhibit.features.map((feature, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visit Information */}
      <section className="py-20 bg-stone-100">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-stone-800 text-center mb-16">參觀資訊</h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-stone-800 mb-6">
                  <i className="ri-information-line text-amber-600 mr-3"></i>
                  展覽須知
                </h3>
                <ul className="space-y-4 text-stone-600">
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 mr-3 mt-1"></i>
                    免費參觀，無需預約
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 mr-3 mt-1"></i>
                    建議參觀時間：90-120分鐘
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 mr-3 mt-1"></i>
                    提供專業導覽服務
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-amber-600 mr-3 mt-1"></i>
                    館內禁止飲食及吸菸
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-stone-800 mb-6">
                  <i className="ri-route-line text-amber-600 mr-3"></i>
                  交通資訊
                </h3>
                <div className="space-y-4 text-stone-600">
                  <div>
                    <h4 className="font-semibold text-stone-800 mb-2">捷運</h4>
                    <p>忠孝新生站1號出口，步行約5分鐘</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-stone-800 mb-2">公車</h4>
                    <p>新生南路口站、建國南路口站</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-stone-800 mb-2">停車</h4>
                    <p>建議使用大眾運輸工具</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for detailed exhibit info */}
      {selectedExhibit && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-3xl font-bold text-stone-800">
                  {exhibits.find(e => e.id === selectedExhibit)?.title}
                </h3>
                <button
                  onClick={() => setSelectedExhibit(null)}
                  className="text-stone-400 hover:text-stone-600 transition-colors"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              <div className="aspect-video mb-6 rounded-xl overflow-hidden">
                <img
                  src={exhibits.find(e => e.id === selectedExhibit)?.image}
                  alt={exhibits.find(e => e.id === selectedExhibit)?.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <p className="text-stone-600 leading-relaxed mb-6">
                {exhibits.find(e => e.id === selectedExhibit)?.description}
              </p>
              
              <div className="flex flex-wrap gap-2">
                {exhibits.find(e => e.id === selectedExhibit)?.features.map((feature, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-amber-100 text-amber-700 rounded-full font-medium"
                  >
                    {feature}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ExhibitionPage;
